//呼叫中心线索库
import { useEffect, useState, useReducer } from 'react'
import CallManageContext from './callManageContext'
import Head from './components/head'
import MainLeft from './components/mainLeft'
import MainRight from './components/mainRight'
import styles from './index.module.less'
import { get } from 'lodash-es'
import { getSignUpRegion, getDateRangeEnum } from '@/services/callCenter'
import { dataDictionary, fetchAllList } from '@/services'
import { getEnums } from '@/services/homeService.ts'
import { useDebounceFn } from 'ahooks'
import { getCustomerSource } from '@/services/customerServices.ts'
import { getClueButton, getDispatchMnrList } from '@/services/saleOpServices.ts'
import { getBusinessDictList } from '@/services/product.ts'
import { getHandleButtonObj } from '@/utils/btn.ts'

// import { createRoot } from 'react-dom/client'

function CallManage(props: any) {
  const { clueId } = props

  const [callManageState, setCallManageState] = useState({
    callAllState: {
      //线索库所有状态
      hasBeenScreening: false, // 高级筛选是否已筛选
      searchType: 'search', //input下拉框值
      detailsRefresh: false, //详情刷新状态
      detailsDispatchStatus: '', //详情线索状态值
      detailsDispatchState: '', //详情线索状态
      isSea: false, // 是否是公海
      followUpDiaryRefresh: false, // 跟进日志刷新数据
      tabValue: '全部', // 頭部tab選中值
      switchState: 'unregister', //
      presentPageUrl: '',
      callJumpRefresh: false, // 跳转呼叫中心刷新
    },
    callList: [], //呼叫列表
    refreshList: false, // 列表刷新
    callFormData: {
      // isPublic: 0, //是否是公海
      key: '', //输入框值
    },
    currentPage: 1, //当前页
    detailParameter: {}, //详情参数
    detailRefresh: false, //刷新详情
    TSDetailId: 0, //暂存详情ID
    callDetails: {}, //线索库 详情
    checkClueList: [], //选中线索列表
    advancedFormData: {
      //高级筛选表单参数
      status: 'ALL',
    },
    detailsTabId: 'userInfo', //当前详情选中的Tab
    softPhoneLoginData: {},
    pendingCauseList: [], //待定原因列表
    discardCauseList: [], //放弃原因列表
    clueId: '',
    clueStatusEnum: [], //线索状态枚举
    callBtnState: {
      loading: false,
      disabled: false, // 呼叫中、通话中 禁用
    }, // 呼叫按钮状态
  })
  const updateCallManageState = (obj = {}) => {
    setCallManageState(pre => {
      return {
        ...pre,
        ...obj,
      }
    })
  }
  const [quickTime, setQuickTime] = useState<any[]>([]) //快捷时间枚举
  const [bizOpPropertyTypeList, setBizOpPropertyTypeList] = useState<any[]>([]) //线索状态枚举
  const [state, dispatch] = useReducer(
    (state: any, action: any) => {
      return action
    },
    {
      companyList: [], //公司
      customerLevelList: [], // 级别
      customerProfessionList: [], // 职业
      customerAgeRangeList: [], // 年龄
      bizOpPropertyTypeList: [], // 房屋属性
      decorationTypeList: [], // 类型
      sourceChannelList: [], // 客户来源
      houseStatusList: [], // 房屋状态
      houseTypeList: [], // 户型
      housePropertyTypeList: [], // 房屋类型
      houseDecorateStyleList: [], // 装修风格
      signBillIntentList: [], // 签单意向
      functionNeedList: [], // 功能需求
    }
  )

  const {
    cityArea,
    companyList, // 派单公司
    sourceChannelList,
  } = state
  useEffect(() => {
    run()
  }, [])
  const { run } = useDebounceFn(
    () => {
      fetchPullDown()
    },
    { wait: 500 }
  )
  useEffect(() => {
    if (clueId) {
      updateCallManageState({
        clueId,
      })
    }
  }, [clueId])

  const handleCity = data => {
    const obj = {}
    return data.reduce((res, item) => {
      if (!obj[item.cityCode]) {
        res.push(item)
      }
      obj[item.cityCode] = true
      return res
    }, [])
  }

  const fetchPullDown = async () => {
    const sourceChannelList = await getCustomerSource()
    const obj = {
      cityArea: await getDispatchMnrList(), // 报名城市
      companyList: await fetchAllList('company'),
      sourceChannelList,
    }

    obj.cityArea = handleCity(obj.cityArea)

    dispatch({ ...obj })
    getBusinessDictList({ data: { priKey: 'ZPendingreason', enabled: true } }).then(res => {
      const list = get(res, '[0].children[0].children', [])
      updateCallManageState({
        pendingCauseList: list,
      })
    })
    getBusinessDictList({ data: { priKey: 'Zabandonreason', enabled: true } }).then(res => {
      const list = get(res, '[0].children[0].children', [])
      updateCallManageState({
        discardCauseList: list,
      })
    })
    // 派单快捷时间枚举
    getDateRangeEnum().then((res: any) => {
      setQuickTime(res)
    })
    // 线索状态枚举
    getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.ClueStatusEnum').then(res => {
      updateCallManageState({
        clueStatusEnum: res || [],
      })
    })
    //房屋属性枚举
    getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.HouseNatureEnum').then(res => {
      console.log('房屋属性枚举------->', res)
      setBizOpPropertyTypeList(res || [])
    })
  }

  return (
    <CallManageContext.Provider value={{ callManageState, updateCallManageState }}>
      <div style={{ height: 'calc(100vh - 250px)' }}>
        <Head
          cityArea={cityArea}
          companyList={companyList}
          sourceChannelList={sourceChannelList}
          bizOpPropertyTypeList={bizOpPropertyTypeList}
          quickTime={quickTime}
        />
        <div className={styles.main}>
          <MainLeft width={500} />
          <MainRight />
        </div>
      </div>
    </CallManageContext.Provider>
  )
}

export default CallManage
